import { FileInput, Label, Modal } from "flowbite-react";
import { useState } from "react";

const accessNested = (obj, key) =>
  key
    .split(".")
    .reduce(
      (_obj, _key) => (typeof _obj === "object" ? _obj[_key] : null),
      obj
    );

const isValidURL = (string) => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};

function FileChooser({
  name,
  label,
  accept,
  formik,
  readOnly,
  showError = true,
  showPreview = true,
  id = "",
}) {
  const formikValue = accessNested(formik.values, name || id);
  const formikError = accessNested(formik.errors, name || id);
  const formikTouched = accessNested(formik.touched, name || id);
  const required = formik.isFieldRequired(name || id);
  return (
    <div>
      {label && (
        <label
          className={`text-sm font-medium text-gray-900 dark:text-gray-300 ${
            required && !readOnly
              ? "after:content-['_*'] after:text-red-500"
              : ""
          }`}
          htmlFor={id}
        >
          {label}
        </label>
      )}
      <div className="mt-2">
        {readOnly ? (
          formikValue?.name || "----"
        ) : (
          <FileInput
            id={id}
            name={name}
            accept={accept}
            onClick={() => {
              formik.setFieldTouched(name, true, true);
            }}
            onChange={(e) => {
              // let reader = new FileReader();
              let file = e.target.files[0];
              formik.setFieldValue(name, file || "");
            }}
          />
        )}
      </div>

      {showPreview && formikValue && (
        <>
          <p
            className="text-blue-500 text-sm cursor-pointer"
            onClick={() => {
              window.open(
                typeof formikValue === "object"
                  ? URL.createObjectURL(formikValue)
                  : typeof formikValue==='string' && !isValidURL(formikValue)
                  ? `${process.env.REACT_APP_ATTACHMENT_URL}${formikValue}`
                  : formikValue
              );
            }}
          >
            {formikValue?.name || "Preview Image"}
          </p>
        </>
      )}
      {showError && (formik?.touched ? formikTouched : false) && (
        <p className="first-letter:uppercase mt-2 text-sm text-red-500">
          {formik?.errors ? formikError : ""}
        </p>
      )}
    </div>
  );
}

export default FileChooser;
